import React from "react";
import Banner from "../../components/Banner";
import Spinner from "../../components/Spinner";
import axios from "axios";
import "../../css/Wireframe.css";

// Helper constants (flattened, no imports)
const API = localStorage.getItem("assethost");
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";

export default class ForgotPasswordNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      errors: {},
      loading: false,
      msg: "",
      toastColor: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    let errors = {};
    let valid = true;
    if (!this.state.newPassword || !this.state.newPassword.trim()) {
      errors.newPassword = "New password is required";
      valid = false;
    } else if (!passwordRegex.test(this.state.newPassword)) {
      errors.newPassword = passwordError;
      valid = false;
    }
    if (!this.state.confirmPassword || !this.state.confirmPassword.trim()) {
      errors.confirmPassword = "Please confirm your new password";
      valid = false;
    } else if (this.state.newPassword !== this.state.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSubmit(e) {
    if (e) e.preventDefault();
    if (!this.validate()) return;
    this.setState({ loading: true, msg: "", toastColor: "" });

    const username = sessionStorage.getItem("username");
    // const code = sessionStorage.getItem("code"); // not used

    axios
      .post(API + "/security/changepassword", {
        username: username,
        password: this.state.newPassword,
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response?.data?.message || "Password reset successfully.",
            toastColor: "success",
          });
          sessionStorage.clear();
          setTimeout(() => {
            window.location.href = "/";
          }, 1200);
        } else {
          this.setState({
            msg: response?.data?.message || "Failed to reset password.",
            toastColor: "danger",
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          errors: {
            general:
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              "Failed to reset password. Please try again.",
          },
          msg:
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            "Failed to reset password. Please try again.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const s = this.state;

    if (s.loading) {
      return <Spinner className="" />;
    }

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    return (
      <div className="min-vh-100 h-dvh d-flex justify-content-center bg-white">
        <div className="min-vh-100 d-flex flex-column flex-grow-1">
          <Banner title="Forgot Password – New Password" />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column align-items-center justify-content-center">
            <form
              className="d-flex flex-column align-items-center w-100 max-w-md mt-8 gap-4"
              autoComplete="off"
              onSubmit={this.handleSubmit}
            >
              <div className="input-group mt-2">
                <label className="input-group-text">New Password</label>
                <input
                  name="newPassword"
                  id="newPassword"
                  type="password"
                  className={`form-control${
                    s.errors.newPassword ? " !border-red-500" : ""
                  }`}
                  value={s.newPassword}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.newPassword && (
                  <span className="input-group-error">
                    {s.errors.newPassword}
                  </span>
                )}
              </div>
              <div className="input-group mt-2">
                <label className="input-group-text">Confirm New Password</label>
                <input
                  name="confirmPassword"
                  id="confirmPassword"
                  type="password"
                  className={`form-control${
                    s.errors.confirmPassword ? " !border-red-500" : ""
                  }`}
                  value={s.confirmPassword}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.confirmPassword && (
                  <span className="input-group-error">
                    {s.errors.confirmPassword}
                  </span>
                )}
              </div>
              <div className="d-flex justify-content-center gap-8 mt-4">
                <button type="submit" className="btn btn-primary">
                  Confirm
                </button>
              </div>
              {s.errors.general && (
                <div className="alert alert-danger mt-2">
                  {s.errors.general}
                </div>
              )}
            </form>
          </div>
          
        </div>
      </div>
    );
  }
}
